import { authorizedFetch } from "../utils/session";

interface Props {
  endpoint: string;
  options?: RequestInit;
  success?: () => void;
  onError?: () => void;
}

export const useRequest = () => {
  const handleRequest = async ({
    endpoint,
    options,
    success,
    onError,
  }: Props): Promise<any> => {
    try {
      // Sign-in must not try to refresh an old session first.
      const response = await authorizedFetch(
        `${process.env.REACT_APP_DEV_API}/${endpoint}`,
        options,
        { refresh: endpoint !== "login" },
      );
      const data = await response.json();
      success && success();
      return data;
    } catch (error) {
      onError && onError();
      throw error;
    }
  };
  return { handleRequest };
};
